import styled from "styled-components";
import ThemeColors from "../../../../themes/colors";

export const MainContainer = styled.div`
  z-index: 2;
  background-color: ${ThemeColors.Bg300};
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  padding: 1.5rem;
  border-radius: 1rem;
  width: 18rem;
  top: 1rem;
  left: 1rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: fixed;
  height: calc(100% - 5.5rem);
  overflow: auto;
`;

export const MenuItems = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const Logo = styled.img`
  height: 1.6rem;
`;
